/**
 * Formats a value as a percent string.
 * Accepts either 0–1 (e.g. 0.15 → "15%") or 0–100 (e.g. 25 → "25%").
 * options.decimals controls how many decimal places to show.
 */
export const formatPercent = (
  value: number,
  options?: { decimals?: number },
): string => {
  const percentValue = value > 0 && value <= 1 ? value * 100 : value;
  return `${Number(percentValue).toFixed(options?.decimals ?? 0)}%`;
};

export const formatPercentNumber = (
  value: number,
  options?: { decimals?: number },
): number => {
  const percentValue = value > 0 && value <= 1 ? value * 100 : value;
  return Number(
    Number(percentValue)
      .toFixed(options?.decimals ?? 0)
      .replace('.00', ''),
  );
};
